"use client";

import { Nav } from "@/components/Nav";
import { Overlay } from "@/components/Overlay";
import classNames from "classnames";
import { useState } from "react";
import styles from "./BurgerMenu.module.css";

export const BurgerMenu = () => {
  const [active, setActive] = useState<boolean>(false);

  return (
    <>
      <button
        className={styles["burger-button"]}
        type="button"
        onClick={() => setActive(!active)}
      >
        <svg
          role="img"
          aria-label="Меню"
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          className={active ? styles.active : ""}
        >
          <line
            className={classNames(styles.line, styles.top)}
            x1="3"
            y1="8.17969"
            x2="22"
            y2="8.17969"
            stroke="#769FCD"
            strokeWidth="3"
          />
          <line
            className={classNames(styles.line, styles.bottom)}
            x1="22"
            y1="16.8281"
            x2="3"
            y2="16.8281"
            stroke="#769FCD"
            strokeWidth="3"
          />
        </svg>
      </button>
      <Nav
        classes={{
          nav: classNames(styles.menu, {
            [styles.active]: active,
          }),
          navLinks: styles["nav-links"],
          navLink: styles["nav-link"],
        }}
        onClick={() => setActive(false)}
      />
      <Overlay className={styles.overlay} active={active} />
    </>
  );
};
